import styled from "styled-components";

export const Container = styled.section`
    width: 100%;    
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    color: #58626c;
    padding: 0 6rem;
    
    h1 {
        font-family: 'Great Vibes', sans-serif;
        font-size: 4rem;
        font-weight: 200;
    }

    @media (max-width: 770px) {
        padding: 0 1rem;
    }

    @media (max-width: 500px) {
        h1 {
            font-size: 3rem;
        }
    }    

`

export const Content = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
    
    div.cardList {  
        display: flex; 
        flex-direction: column;
        justify-content: center;
        align-items: center;     
        margin: 20px 10px;
        transform: scale(1);
        transition: all ease 1s;

        img {
            object-fit: cover;
            object-position: top;
            height: 200px;
            width: 200px;
            border-radius: 5px;
        }
    }   

    div.description {
        p {
            margin-top: .3rem;
            max-width: 1100px;
        }
    }

    @media (min-width: 1000px) {
        div.cardList:hover { 
            position: relative;
            z-index: 9;
            transform: scale(2);
        }
        div.description {
            background: var(--background);
            
        }
    }

`